import { API } from "aws-amplify"

import * as Sentry from "@sentry/react"

const defaultProps = {
  response: true,
  headers: { "x-api-key": window.atob(process.env.REACT_APP_AMPLIFY_API_API_KEY) },
}

const mockServicePath = "mock"

export const mockSuccess = async () => {
  try {
    const { data } = await API.get(
      process.env.REACT_APP_AMPLIFY_API_ENDPOINT_NAME,
      `/${mockServicePath}/success`,
      {
        ...defaultProps,
      }
    )

    return data
  } catch (error) {
    Sentry.captureException(error, { tags: { context: "api", noFallback: true } })

    throw error
  }
}

export const mockError = async () => {
  try {
    await API.get(
      process.env.REACT_APP_AMPLIFY_API_ENDPOINT_NAME,
      `/${mockServicePath}/error`,
      {
        ...defaultProps,
      }
    )
  } catch (error) {
    Sentry.captureException(error, { tags: { context: "api", noFallback: true } })

    throw error
  }
}
